// extracted by mini-css-extract-plugin
export default {"addressButton":"FotKF"};